export default __webpack_public_path__ + "static/media/no-result.0a35ec4d.jpg";